import { oc } from '@orpc/contract';
import { contactSchema, createContactInputSchema } from '../schemas/contacts.schemas.js';
export const createContactContract = oc
    .route({
    method: 'POST',
    path: '/contacts',
    tags: ['Contacts'],
    summary: 'Create a contact',
})
    .input(createContactInputSchema)
    .output(contactSchema);
//# sourceMappingURL=create-contact.contract.js.map